module.exports = __webpack_public_path__ + "static/ecommerce-01f6b8df4de5ae2d571e3a503d848a1e.jpg";